var map = {
	"./Coate-and-Cha.jpg": 100,
	"./Deans-Award-Winners_2022.jpg": 101,
	"./Diabetes-Day-2022.jpg": 102,
	"./Diabetes-group-vanderbilt-saunders-brissova-haliyur.jpg": 103,
	"./Diabetes-research-group-ES-4.jpg": 104,
	"./Fowler_DKA.jpeg": 105,
	"./Pancreatic-pseudoislet-system-pancreas-diabetest-research.jpg": 106,
	"./Pettway_Yasminye_edited-1-433x450.jpg": 107,
	"./Saunders_Diane-2022_edited-1.jpg": 108,
	"./Wright-and-Eskaros-Pancreas.jpg": 45,
	"./nature_photo.jpg": 44,
	"./pancreatlas.jpg": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;